import Vue from 'vue';
import Router from 'vue-router';
import { loginURL } from '@/dex-shared/settings/endpoints';
import store from '@/store/index';
import Classroom from './views/Classroom.vue';
import Corrections from './views/Corrections.vue';
import Drafts from './views/Drafts.vue';
import Essay from './views/Essay.vue';
import Correction from './views/Correction.vue';

Vue.use(Router);

const isAuthenticated = () =>
  !!((store.state as any).auth.user && (store.state as any).auth.user.id);
const isVisibleUnlogged = routeName => {
  const visibleUnloggedRoutes = ['login'];
  return visibleUnloggedRoutes.includes(routeName);
};
const notVisibleLogged = routeName => {
  const invisibleLoggedRoutes = ['login'];
  return invisibleLoggedRoutes.includes(routeName);
};

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Classroom,
    },
    {
      path: '/correcoes',
      name: 'corrections',
      component: Corrections,
    },
    {
      path: '/rascunhos',
      name: 'drafts',
      component: Drafts,
    },
    {
      path: '/entrar',
      name: 'login',
      beforeEnter() {
        const path = encodeURIComponent(window.location.href);
        const loginPath = `${loginURL}/?returnUrl=${path}`;
        window.location.assign(loginPath);
      },
    },
    {
      path: '/tema/:subjectSlug',
      name: 'subject',
      component: Essay,
    },
    {
      path: '/tema/:subjectSlug/:position',
      name: 'essay',
      component: Essay,
    },
    {
      path: '/tema/:subjectSlug/:position/correcao',
      name: 'correction',
      component: Correction,
    },
  ],
});

router.beforeEach((to, _from, next) => {
  if (!isAuthenticated() && !isVisibleUnlogged(to.name)) {
    router.push('/entrar');
  } else if (isAuthenticated() && !store.getters.userShouldSeeDexEssays) {
    window.location.assign(store.getters.essaysUrl);
  } else if (isAuthenticated() && notVisibleLogged(to.name)) {
    router.push('/');
  } else {
    next();
  }
});

export default router;
